import React from "react";
import { Box, Button, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

interface NonActivatedCardProps {
    setIsOptionalActivated: React.Dispatch<React.SetStateAction<boolean>>
}

const NonActivatedCard = (props:NonActivatedCardProps) => {
  const features = [
    {
      title: "Hyper Personalised RECOMMENDATION",
      description: "Machine Learning based, most optimised and Hyper Personalised TARGET for each store, for each call.",
    },
    {
      title: "Task Based INCENTIVE",
      description: "For every TASK to drive right Action with instant gratification",
    },
    {
      title: "Add On FEATURE",
      description: "Feature streamlining ordering and enhancing tracking tasks",
    },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #E0F7FA",
        borderRadius: "10px",
        overflow: "hidden",
        width:"100%",
        height:"100%",
        position:"absolute",
        top:"0",
        left:"0",
        display:"flex",
        flexDirection:"column",
        justifyContent:"space-between",
     
      }}
    >
      <Box>
      <Box sx={{ padding: "20px", textAlign: "center" }}>
        <Typography variant="h6" sx={{ color: "#227C9D" }}>
          Enhance your experience by adding advanced features <strong>upgrade now!</strong>
        </Typography>
      
      </Box>

      <Box sx={{ padding: "10px" }}>
        {features.map((feature, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "15px",
            }}
          >
            <StarIcon sx={{ color: "#FFCA28", marginRight: "10px", fontSize: "15px" }} />
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "600", color: "#333" }}
              >
                {feature.title}
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", fontSize: "13px" }}>
                {feature.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      </Box>

      <Box sx={{ padding: "20px", textAlign: "center"}}>
        <Button
          variant="contained"
          onClick={(e)=>props.setIsOptionalActivated(true)}
          sx={{
            backgroundColor: "#20c997",
            color: "#FFFFFF",
            fontWeight: "bold",
            borderRadius: "8px",
            padding: "8px 20px",
            width:"80%" ,
            ":hover": { backgroundColor: "#20c997" },
          }}
        >
          EXPLORE FEATURES
        </Button>
        <Typography
          variant="caption"
          sx={{ display: "block", marginTop: "4px", color: "#999" }}
        >
          Trusted by top companies
        </Typography>
      </Box>

      
    </Box>
  );
};

export default NonActivatedCard;
